import React from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { applicationsListTable, applicationsTableOptions } from "../../../shared/tableObjects/admin/applicationsListTable";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";
export default function ApplicationsList() {
  const apiClient = useApiClient("BaseApplication");
  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "List of Applications",
      icon: "list-icon",
    },
  ];

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />
        <Table apiClient={apiClient} label={""} columns={applicationsListTable("applications")} tableOptions={applicationsTableOptions} />
      </div>
    </>
  );
}
